import type { App as VueApp } from 'vue';
import { setupStores } from './setupStores';
import { setupRouter } from './setupRouter';
import { setupRuntime } from './setupRuntime';

export const setupApp = async(app: VueApp<Element>) => {
    setupStores(app);
    setupRouter(app);
    setupRuntime(app);
}
